"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pca_1 = require("./pca");
exports.PCA = pca_1.PCA;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2RlY29tcG9zaXRpb24vaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw2QkFBNEI7QUFFbkIsY0FGQSxTQUFHLENBRUEifQ==